import { Component } from '@angular/core';
import { FitnessChallengesGridResponseData } from '../../../models/fitness/fitnessChallengesGridResponse';
import { FitnessChallengesGridRequest } from '../../../models/fitness/fitnessChallengesGridRequest';
import { PhysicalFitnessService } from '../../../services/physical-fitness.service';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { AnyoTableComponent } from 'projects/app-core/src/app/models/AnyoTableComponent';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrl: './manage.component.scss'
})
export class ManageComponent extends AnyoTableComponent<FitnessChallengesGridResponseData, FitnessChallengesGridRequest> {
  globalSearchInput = '';
  loader = false;
  tableData: FitnessChallengesGridResponseData[] = [];
  page = 1;
  totalChallengesCount = 0;
  showTestCount = false;

  showTestUsers() {
    if (!this.gridRequest) {
      this.gridRequest = {
        page: this.page,
        pageSize: this.pageSize,
        globalSearch: [],
        export: false
      }
    }
    if (!this.gridRequest.filters) {
      this.gridRequest.filters = {
        TEST_CHALLENGES: undefined,
      };
    }
    this.gridRequest.filters!.TEST_CHALLENGES = this.showTestCount ? ['false'] : ['true']
    this.getData()
  }

  constructor(
    protected override auth: AuthService,
    protected override toastService: ToastService,
    private fit: PhysicalFitnessService,
    public utils: UtilsService

  ) {
    super(auth, toastService);
  }

  async getData() {
    this.loader = true;
    this.fit.fetchFitnessChallengesGrid(this.gridRequest).subscribe({
      next: (value) => {
        this.tableData = value.data;
        this.page = value.pageNum;
        this.totalChallengesCount = value.totalRecords;
        this.loader = false;
      }, error: (err) => {
        this.loader = false;
        const errorBody = err.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      }
    })
  }



  searchGlobal() {
    this.gridRequest.globalSearch?.push(this.globalSearchInput.trim());
    this.getData();
  }
  override async resetFilter() {
    this.gridRequest = {
      page: 1,
      pageSize: this.pageSize,
      globalSearch: [],
      filters: {
        TEST_CHALLENGES: ["true"]
      },
      export: false
    }
    this.showTestCount = false;
    this.globalSearchInput = '';
    this.getData();
  }

  override ngOnInit() {
    this.auth.currentAuthStatus.subscribe((user) => {
      if (user) {
        this.loader = true;
          this.gridRequest = {
            page: this.page,
            pageSize: this.pageSize,
            globalSearch: [],
            filters: {
              TEST_CHALLENGES: ["true"]
            },
            export: false
          }
        this.getData();
      }
    })
  }
}
